import React, { useState } from 'react'
import Button from '../Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'

// Define the props for our StringList component
interface StringListProps {
    value: string[] // Current list of strings
    onChange: (newValue: string[]) => void // Callback to update the list
    addButtonText: string
    className?: string
}

const StringList: React.FC<StringListProps> = ({
    value,
    onChange,
    addButtonText,
    className,
}) => {
    // Controls whether the modal is open
    const [showModal, setShowModal] = useState<boolean>(false)
    // Temporary value for the new item
    const [newItem, setNewItem] = useState<string>('')

    // Open the popup
    const handleAddClick = () => {
        setShowModal(true)
    }

    // Confirm adding the new item
    const handleSave = () => {
        const trimmed = newItem.trim()
        if (trimmed !== '') {
            onChange([...value, trimmed])
            setNewItem('')
        }
        setShowModal(false)
    }

    // Cancel adding
    const handleCancel = () => {
        setNewItem('')
        setShowModal(false)
    }

    // Remove an item from the list by index
    const handleRemove = (index: number) => {
        const updatedList = value.filter((_, i) => i !== index)
        onChange(updatedList)
    }

    return (
        <div className={className}>
            <Button
                type="button"
                style="secondary"
                classes=""
                onClick={handleAddClick}
            >
                {addButtonText}
            </Button>

            {/* Render the list of strings */}
            <ul className="mt-4 space-y-2 max-w-2xl">
                {value.map((item, index) => (
                    <li
                        key={index}
                        className="flex items-center justify-between bg-ctxt-blue bg-opacity-20 px-4 py-2 rounded-lg"
                    >
                        <span>{item}</span>
                        <Button
                            style="mild-danger"
                            type="button"
                            classes=""
                            size="small"
                            onClick={() => handleRemove(index)}
                        >
                            <FontAwesomeIcon icon={faTrashCan} />
                        </Button>
                        {/* <button
                            type="button"
                            className="text-red-500 font-bold ml-4"
                            onClick={() => handleRemove(index)}
                        >
                            X
                        </button> */}
                    </li>
                ))}
            </ul>

            {/* Popup (modal) for adding a new item */}
            {showModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-4 rounded shadow-md w-80">
                        <h2 className="text-xl font-bold mb-2">
                            Add a new item
                        </h2>
                        <input
                            type="text"
                            className="border rounded px-2 py-1 w-full"
                            value={newItem}
                            onChange={(e) => setNewItem(e.target.value)}
                        />
                        <div className="mt-4 flex justify-end space-x-2">
                            <button
                                type="button"
                                className="bg-gray-300 text-black px-4 py-2 rounded"
                                onClick={handleCancel}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="bg-blue-500 text-white px-4 py-2 rounded"
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default StringList
